<template>
    <div class="collapsible-container" :class="{show: !closed || alwaysOpen, alwaysOpen}">
        <div class="link" @click="globalClick">
            <div class="holder">
                <svgicon v-if="icon" :src="icon" class="icon" width="20" height="20"/>
                <div class="triangle" v-if="dot" @click="innerClick"></div>
                <NavigationLink v-if="url" :url="url" @click="openCollapse">{{text}}</NavigationLink>
                <span v-if="!url">{{text}}</span>
                <div class="collapsible-icon" @click="innerClick">
                    <svgicon src="/icon/arrow.svg" :height="15" :width="15"></svgicon>
                </div>
            </div>
        </div>
        <div class="collapsible">
            <slot />
        </div>
    </div>
</template>

<script>
  import NavigationLink from '@/components/navigation/Link.vue';

  export default {
    name: "collapse",

    components: { NavigationLink },

    props: {
      icon: String,
      text: String,
      url: String,
      dot: Boolean,
      closed: Boolean,
      alwaysOpen: Boolean
    },

    methods: {
      collapse(e) {
        if (this.alwaysOpen) {
          return;
        }
        this.$el.classList.toggle("show");
      },
      innerClick() {
        if (this.url) {
          this.collapse();
        }
      },
      openCollapse() {
        this.$el.classList.add("show");
      },
      globalClick() {
        if (!this.url) {
          this.collapse();
        }
      }
    }
  }
</script>

<style lang="scss">
  #navigation {
    $item-padding: 5px 20px 5px 50px;
    $item-font-size: 14px;

    .collapsible-container {
      flex-direction: column;
      text-decoration: none;
      border-bottom: 1px solid #262626;
      cursor: initial;

      & > .link {
        cursor: initial;

        & > .holder > .link {
          &.router-link-exact-active {
            color: white;
          }
        }
      }

      &:not(.alwaysOpen) {
        & > .link {
          cursor: pointer;
        }
      }

      &.alwaysOpen {
        .collapsible-icon {
          opacity: 0;
          pointer-events: none;
        }
      }

      &.active {
        & > .link > .holder {
          background-color: #333;
          border-radius: 5px;
          color: white;

          .icon {
            fill: var(--primary-color);
          }
        }
      }

      .holder {
        display: flex;
        width: 100%;
      }

      & > .collapsible {

        &:not(.alwaysOpen) {
          display: none;
        }

        & > .link {
          padding: $item-padding;
          font-size: $item-font-size;

          &.router-link-exact-active {
            color: #fff;
          }
        }

        & > .collapsible-container {
          border-bottom: 0;

          &:last-child {
            padding-bottom: 15px;
          }

          &.show {
            & > .link > .holder > .triangle {
              transform: rotate(-180deg);
            }
          }

          &.active {
            & > .link > .holder {
              color: var(--primary-color);
            }
          }

          & > .link {
            padding: $item-padding;
            font-size: $item-font-size;

            & > .holder {
              padding: 0;
              background-color: initial;

              .collapsible-icon {
                pointer-events: none;
                opacity: 0;
              }

              & > .triangle {
                width: 0;
                height: 0;
                background-color: initial;
                border-radius: 0;
                margin-right: 10px;
                margin-left: 10px;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 10px solid #404040;
                cursor: pointer;
              }

              & > .collapsible-icon {
                display: none;
              }
            }
          }

          & > .collapsible {
            border-bottom: 0;

            & > .link {
              padding-left: 70px;

              &:last-child {
                padding-bottom: 5px;
              }
            }
          }
        }
      }

      .link {
        border-bottom: 0;
        border-left: 0;
        user-select: none;

        &:last-child {
          padding-bottom: 20px;
        }
      }

      & > .link {
        padding: 10px 10px;

        & > .holder {
          padding: 0 0 0 10px;
          display: flex;
          align-items: center;
        }
      }

      &.show {
        border-bottom: none;

        & > .collapsible {
          display: block;
          border-bottom: 1px solid #262626;
        }

        & > .link {
          > .holder > .collapsible-icon {
            transform: rotateZ(-180deg);
          }
        }
      }
    }

    .collapsible-icon {
      margin-left: auto;
      fill: #808080;
      cursor: pointer;
      padding: 10px;
    }

    .svgicon {
      fill: #404040;
    }

    .icon {
      margin-right: 20px;
    }
  }
</style>